import React from "react";
import { Link } from "gatsby";

import { connect } from "react-redux";

import Layout from "../components/layout";
import AnswerButton from "./AnswerButton";
import { format, nl2br } from "../utils/formatters";

var MarkdownIt = require("markdown-it"),
  md = new MarkdownIt();

const Question = (props) => {
  const { node } = props.pageContext;
  const options = node.on;
  options.sort((a, b) => {
    if (a.text < b.text) {
      return -1;
    }
    if (a.text > b.text) {
      return 1;
    }
    return 0;
  });

  const makeSlug = (language, prefix, slug) => {
    return language === "en"
      ? `${prefix}/${slug}/`
      : `${prefix}/${language}/${slug}`;
  };

  const optionsLis = options.map((option, i) => {
    const nextState = option.toState;
    const linkTo = makeSlug(node.language, node.prefix, nextState);
    return (
      <AnswerButton
        linkTo={`/${linkTo}`}
        text={option.text}
        key={`${option.text}${i}`}
        onClick={(e) => {
          if (node.extraData.addToHistory !== false) {
            props.addAnswer({
              question: node.question,
              answer: option.text,
              slug: makeSlug(node.language, node.prefix, node.slug),
            });
          }
        }}
      />
    );
  });

  const back =
    props.questionHistory.length > 0
      ? props.questionHistory[props.questionHistory.length - 1]
      : null;
  const backElem = back ? (
    <Link
      to={`/${back.slug}`}
      onClick={(e) => {
        props.popAnswers(1);
      }}
    >
      {getText("PREVIOUS_QUESTION", node.language)}
    </Link>
  ) : null;

  console.log("NODE LANGUAGE?", node.language);

  const homeURL =
    node.language === "en"
      ? `/${node.prefix}`
      : `/${node.prefix}/${node.language}`;
  const homeElem =
    props.questionHistory.length > 0 ? (
      <Link to={homeURL} onClick={(e) => props.resetAnswers()}>
        {getText("START_AGAIN", node.language)}
      </Link>
    ) : null;

  const linksDivider = backElem !== null && homeElem !== null ? " / " : null;

  const question = format(node.question, [nl2br]);

  let textEl;
  if (node.extraData.component) {
    const Component = require("../questions/" + node.extraData.component.path);
    textEl = (
      <Component.default
        prefix={node.prefix}
        language={node.language}
      ></Component.default>
    );
  } else {
    const renderedQuestion = md.render(node.question);
    textEl = (
      <div
        className="questionText"
        dangerouslySetInnerHTML={{ __html: renderedQuestion }}
      />
    );
  }

  let noteEl;
  if (node.note) {
    const renderedNote = md.render(node.note);
    noteEl = (
      <div
        className="questionNote"
        dangerouslySetInnerHTML={{ __html: renderedNote }}
      />
    );
  }

  return (
    <Layout title={node.title} prefix={node.prefix}>
      <div>
        <div className="question">
          {textEl}
          {noteEl}
          <ul className="answers">{optionsLis}</ul>
          {homeElem}
          {linksDivider}
          {backElem}
        </div>
      </div>
    </Layout>
  );
};

const getText = (text, language) => {
  console.log("looking up", text, language);
  const texts = {
    START_AGAIN: {
      en: "Start again",
      bg: "Започнете отново",
      it: "Ricomincia",
      ru: "Начать снова",
      es: "Volver a empezar",
      hi: "फिर से शुरू करें",
    },
    PREVIOUS_QUESTION: {
      en: "Previous question",
      bg: "Предишен въпрос",
      it: "Domanda precedente",
      ru: "Предыдущий вопрос",
      es: "Pregunta anterior",
      hi: "पिछला प्रश्न",
    },
  };
  return texts[text][language];
};

const mapStateToProps = ({ questionHistory }) => {
  return { questionHistory };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAnswer: (questionAnswer) => {
      dispatch({ type: `ADD_ANSWER`, answer: questionAnswer });
    },
    popAnswers: (n) => {
      dispatch({ type: `POP_ANSWERS`, n: n });
    },
    resetAnswers: () => {
      dispatch({ type: `RESET_ANSWERS` });
    },
  };
};

const ConnectedQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(Question);

export default ConnectedQuestion;
